import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import UserProfilesPartnershipForm from '../containers/UserProfilesPartnershipFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class UserProfilesPartnershipAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `UserProfilesPartnershipAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('user_profiles_partnership_route_add')} />
          <UserProfilesPartnershipForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default UserProfilesPartnershipAddScreen;

Logger.log('silly', `UserProfilesPartnershipAddScreen loaded.`);
